import { FC } from 'react';
import { IconProps, IconColor } from '../types';

export const ReloadIcon: FC<IconProps> = ({
  width = 24,
  height = 24,
  fillColor = IconColor.TEXT_PRIMARY,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 19C13.9542 19 15.6094 18.3219 16.9656 16.9656C18.3219 15.6094 19 13.9542 19 12C19 10.0458 18.3219 8.39062 16.9656 7.03437C15.6094 5.67812 13.9542 5 12 5C10.9938 5 10.0312 5.20781 9.1125 5.62344C8.19375 6.03906 7.40625 6.63333 6.75 7.40625V5H5V11.125H11.125V9.375H7.45C7.91667 8.55833 8.55469 7.91667 9.36406 7.45C10.1734 6.98333 11.0521 6.75 12 6.75C13.4583 6.75 14.6979 7.26042 15.7188 8.28125C16.7396 9.30208 17.25 10.5417 17.25 12C17.25 13.4583 16.7396 14.6979 15.7188 15.7188C14.6979 16.7396 13.4583 17.25 12 17.25C10.8771 17.25 9.86354 16.9292 8.95938 16.2875C8.05521 15.6458 7.42083 14.8 7.05625 13.75H5.21875C5.62708 15.2958 6.45833 16.5573 7.7125 17.5344C8.96667 18.5115 10.3958 19 12 19Z"
        fill={fillColor}
      />
    </svg>
  );
};
